import { LegacyRef, useState } from 'react';

import { useTranslation } from 'react-i18next';

import { TextField, TextFieldType } from '@cfa/react-components';

import Constants from 'constants/index';

interface EditSectionNameProps {
  onEnter: () => void;
  originalSectionTitle: string;
  refSectionTitle: LegacyRef<TextFieldType>;
  updateSectionTitle: (title: string) => void;
}

const EditSectionName: React.FC<EditSectionNameProps> = ({
  originalSectionTitle,
  refSectionTitle,
  updateSectionTitle,
  onEnter,
}) => {
  const [sectionTitle, setSectionTitle] = useState(originalSectionTitle);
  const maxLength = Constants.FORMS.MAX_SECTION_LENGTH;
  const { t } = useTranslation();
  const handleOnChange = (e: React.ChangeEvent<TextFieldType>) => {
    setSectionTitle(e.target.value);
    updateSectionTitle(e.target.value);
  };

  return (
    <div className="relative mb-4 flex w-full">
      <TextField
        fullWidth
        maxLength={maxLength}
        onChange={e => handleOnChange(e)}
        onKeyDown={e => e.key === 'Enter' && onEnter()}
        placeholder={t('TrainingPlans.sectionName')}
        ref={refSectionTitle}
        type="text"
        value={sectionTitle}
      />
      {!!sectionTitle.length && (
        <div className="absolute right-0.5 -bottom-5 flex">
          <div className="text-grayscale-gray6 flex items-end justify-end text-xs font-normal italic">
            {`${sectionTitle.length}/${maxLength}`}
          </div>
        </div>
      )}
    </div>
  );
};

export default EditSectionName;
